import { render, staticRenderFns } from "./Client.vue?vue&type=template&id=161c87b9&scoped=true&"
import script from "./Client.vue?vue&type=script&lang=js&"
export * from "./Client.vue?vue&type=script&lang=js&"
import style0 from "./Client.vue?vue&type=style&index=0&id=161c87b9&scoped=true&lang=css&"
import style1 from "./Client.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161c87b9",
  null
  
)

export default component.exports